/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* `httpResource` is still an experimental feature - NOT PRODUCTION READY
* Generated Angular service for PluginResource
* Do not edit this file manually
*/
import { HttpContext, HttpContextToken, HttpHeaders, HttpParams, httpResource, HttpResourceOptions, HttpResourceRef, HttpResourceRequest } from "@angular/common/http";
import { inject, Injectable, Signal } from "@angular/core";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { GetPluginByIdResponse, GetPluginsResponse, GetPluginSelectResponse } from "../models";

@Injectable({ providedIn: "root" })
export class PluginResource {
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getPluginById(id: Signal<number> | number, resourceOptions: HttpResourceOptions<GetPluginByIdResponse, unknown> & { defaultValue: NoInfer<GetPluginByIdResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetPluginByIdResponse>;
    getPluginById(id: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetPluginByIdResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetPluginByIdResponse | undefined>;
    getPluginById(id: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetPluginByIdResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetPluginByIdResponse | undefined> {
        return httpResource(() => {
            return {
                url: `${this.basePath}/Plugin/${typeof id === 'function' ? id() : id}`,
                method: "GET",
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getPlugins(searchTerm: Signal<string | null | undefined> | string | null | undefined, resourceOptions: HttpResourceOptions<GetPluginsResponse, unknown> & { defaultValue: NoInfer<GetPluginsResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetPluginsResponse>;
    getPlugins(searchTerm?: Signal<string | null | undefined> | string | null, resourceOptions?: HttpResourceOptions<GetPluginsResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetPluginsResponse | undefined>;
    getPlugins(searchTerm?: Signal<string | null | undefined> | string | null, resourceOptions?: HttpResourceOptions<GetPluginsResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetPluginsResponse | undefined> {
        return httpResource(() => {
            let params = new HttpParams();
            const searchTermValue = typeof searchTerm === 'function' ? searchTerm() : searchTerm;
            if (searchTermValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, searchTermValue, 'searchTerm');
            }
            return {
                url: `${this.basePath}/Plugin`,
                method: "GET",
                params,
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getPluginSelect(resourceOptions: HttpResourceOptions<GetPluginSelectResponse, unknown> & { defaultValue: NoInfer<GetPluginSelectResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetPluginSelectResponse>;
    getPluginSelect(resourceOptions?: HttpResourceOptions<GetPluginSelectResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetPluginSelectResponse | undefined>;
    getPluginSelect(resourceOptions?: HttpResourceOptions<GetPluginSelectResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetPluginSelectResponse | undefined> {
        return httpResource(() => {
            return {
                url: `${this.basePath}/Plugin/Select`,
                method: "GET",
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }
}
